import React, { useEffect } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ShieldAlert } from "lucide-react";
import { useAuth } from "../lib/AuthContext";
import TwoFactorSection from "../components/settings/TwoFactorSection";

export default function EnrollTwoFactor() {
  const { t } = useTranslation("auth");
  const { user, refresh, logout } = useAuth();
  const navigate = useNavigate();

  // Once the user finishes enrolling, /auth/me flips to "ok" -> leave the wall.
  useEffect(() => {
    if (user && user !== false && user.mfa_status === "ok") {
      navigate("/dashboard", { replace: true });
    }
  }, [user, navigate]);

  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center text-sm text-zinc-400">
        {t("two_factor.enforcement.checking")}
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // Users who don't actually need enrollment shouldn't see the wall.
  if (user.mfa_status === "ok") return <Navigate to="/dashboard" replace />;

  return (
    <div className="min-h-screen bg-zinc-50 flex items-start justify-center px-4 py-16">
      <div className="w-full max-w-lg">
        <div className="flex items-center gap-3 mb-6">
          <span className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-amber-100 text-amber-700">
            <ShieldAlert size={20} strokeWidth={1.75} />
          </span>
          <div>
            <h1 className="font-display text-2xl font-semibold text-zinc-950">
              {t("two_factor.enforcement.required_title")}
            </h1>
            <p className="text-sm text-zinc-500 mt-1 max-w-md">
              {t("two_factor.enforcement.required_subtitle")}
            </p>
          </div>
        </div>
        <TwoFactorSection onEnabled={refresh} />
        <button
          onClick={logout}
          className="mt-6 text-xs text-zinc-500 hover:text-zinc-900 transition-colors"
          data-testid="enroll-2fa-signout"
        >
          {t("two_factor.enforcement.sign_out")}
        </button>
      </div>
    </div>
  );
}
